<script>
  export default {
    name: 'dashboard-box-link',
    props: ['number', 'iconClass', 'title', 'href', 'to', 'click']
  }
</script>

<template>
    <div class="box box-10 box-link" v-bind:class="number">
        <router-link v-if="to" :to="to" class="link-content">
            <div>
                <div class="link-icon">
                    <i v-bind:class="iconClass"></i>
                </div>
                <div class="link-text">{{title}}</div>
            </div>
        </router-link>
        <a v-if="href" :href="href" v-bind:target="{'_blank' : href}" class="link-content">
            <div>
                <div class="link-icon">
                    <i v-bind:class="iconClass"></i>
                </div>
                <div class="link-text">{{title}}</div>
            </div>
        </a>
        <div v-if="!href && !to" class="link-content" @click="click()">
            <div>
                <div class="link-icon">
                    <i v-bind:class="iconClass"></i>
                </div>
                <div class="link-text">{{title}}</div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .dashboard {
        .box-link {
            -webkit-transition: all .4s ease-in-out;
            transition: all .4s ease-in-out;
            text-decoration: none;
            cursor: pointer;

            &:hover {
                -webkit-animation: Gradient 10s ease infinite;
                animation: Gradient 10s ease infinite;

                > .link-content > div .link-text {
                    color: #FFF;
                }
            }

            > .link-content {
                width: 100%;
                height: 100%;
                display: -webkit-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-align: center;
                -ms-flex-align: center;
                align-items: center;
                text-decoration: none;
                > div {
                    width: 100%;
                    .link-icon {
                        padding-top: 15px;
                        text-align: center;
                        svg {
                            font-size: 50px;
                            path {
                                fill: rgba(0, 0, 0, 0.2);
                            }
                        }
                    }
                    .link-text {
                        color: #727272;
                        font-weight: 600;
                        text-align: center;
                        padding: 18px 15px 0;
                        font-size: 21px;
                        line-height: 28px;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// BoxLink.vue?3a64b4a6